import React, { useContext, useEffect, useState } from 'react';
import './payDetailTab.css'
import moment from "moment";
import { CommonDateRange, CommonInput, CommonModal } from 'components/common';
import { AddSupplierPayment, MakePaymentSupplierModal, PaymentVoucher } from 'modals';
import BootstrapTable from 'components/BootstrapTable';
import CustomPagination from 'components/CustomPagination';
import { StorageServices } from 'utils';
import { deleteSupplierPayment, getSupplierPaymentList } from '_services/accountsServices/supplierServices';
import { utils } from 'helper';
import { UserContext } from 'context';
import { Link } from 'react-router-dom';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaRegTrashCan } from 'react-icons/fa6';
import toast from 'react-hot-toast';

const PaymentDetailsTabs = ({ supplierDetails }) => {

    const [showOffAddPayOffCanva, setShowAddPayOffCanva] = useState(false);
    const [supplierPaymentList, setSuppliePaymentList] = useState([])
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        status: 1
    });
    const [isOpenFreight, setIsOpenFreight] = useState({ open: false, type: "" });
    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const { masterData } = useContext(UserContext)
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
    const [confirmModalShow, setConfirmModalShow] = useState(false);



    const handleApply = (newRange) => {
        setSelectedRange({
            startDate: moment(newRange.startDate).startOf('day'),
            endDate: moment(newRange.endDate).endOf('day')
        });
        setFilter((s) => ({ ...s, offset: 1 }));
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setFilter((s) => ({ ...s, search: value, offset: 1 }));
    };

    // Row click handler - opens payment voucher
    const handleRowClick = (e, item) => {
        // Agar dropdown ya delete button pe click hua to row click ignore karo
        setPaymentVoucherOpen(item);
    };

    const columns = [
        { header: "", accessor: "serial" },
        { header: "Transaction Date", accessor: "transactionDate" },
        { header: "Trip Number", accessor: "tripNumber" },
        { header: "Invoice Number", accessor: "invoiceNumber" },
        { header: "Payment Type", accessor: "paymentType" },
        { header: "Status", accessor: "status" },
        { header: "Payment Mode", accessor: "paymentMode" },
        { header: "From Account", accessor: "fromAccount" },
        { header: "To Account", accessor: "toAccount" },
        { header: "Amount {₹}", accessor: "ToalAmount" },
        { header: "Generated By", accessor: "generatedBy" },
    ];

    // Multiple trip numbers ko clickable links me convert karne ke liye
    function renderTripNumbers(item) {
        // Agar single trip hai (type 1 - Trip Freight)
        if (item?.trip?._id && item?.trip?.trip_number) {
            return (
                <Link 
                    to={`/trip/addtrip/dispatched/${item.trip._id}?t=freight`}
                    onClick={(e) => e.stopPropagation()}
                    style={{ cursor: 'pointer', color: '#0066cc', textDecoration: 'underline' }}
                >
                    {item.trip.trip_number}
                </Link>
            );
        }
        
        // Agar categories me trips hain (type 21 - Bulk Payment)
        if (item?.categories && item.categories.length > 0) {
            // Filter out categories that have trip_id
            const tripsWithId = item.categories.filter(cat => cat.trip_id && cat.trip_number);
            
            if (tripsWithId.length > 0) {
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                        {tripsWithId.map((category, index) => (
                            <React.Fragment key={category.trip_id || index}>
                                <Link 
                                    to={`/trip/addtrip/dispatched/${category.trip_id}?t=freight`}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ cursor: 'pointer', color: '#0066cc', textDecoration: 'underline' }}
                                >
                                    {category.trip_number}
                                </Link>
                                {index < tripsWithId.length - 1 && <span style={{ color: '#666' }}> , </span>}
                            </React.Fragment>
                        ))}
                    </div>
                );
            }
        }
        
        return <span style={{ color: '#666' }}>-</span>;
    }

    function RowListData(data) {
        return (
            data?.map((item, i) => ({
                ...item,
                
                serial: (
                    <React.Fragment>
                        <div className="signDropdown">
                            <button className="dropbtn11">
                                <BsThreeDotsVertical />
                            </button>
                            <div className="dropdownContent">
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation(); // Row click ko trigger hone se rokna
                                        deleteHandler(item);
                                    }}
                                    className="_avPointer"
                                >
                                    <span className="_samAnchor">
                                        <span className="deleteIcon_avt">
                                            <FaRegTrashCan color="red" />
                                        </span>
                                        Delete
                                    </span>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                ),
                transactionDate: utils?.customizeDate(item?.date),
                paymentType: item?.sub_type_name || item?.type_name || "-",
                paymentMode: item?.payment_mode?.name || "-",
                fromAccount: item?.from_account?.name || "-",
                toAccount: item?.to_account?.name || "-",
                tripNumber: renderTripNumbers(item),
                status: <>
                    {item?.approval_status != 0 ? (
                        <span
                            className={`tagBxs ${item?.approval_status === 1
                                ? "pending"
                                : item?.approval_status === 2
                                    ? "hold"
                                    : item?.approval_status === 3
                                        ? "approved"
                                        : item?.approval_status === 4
                                            ? "rejected"
                                            : item?.approval_status === 5
                                                ? "complete"
                                                : "complete"
                                }`}
                        >
                            {" "}
                            {masterData?.payment_approval_status[item?.approval_status]}
                        </span>
                    ):"-"}
                </>,
                generatedBy: item?.created_by?.full_name || "-",
                ToalAmount:(item?.total_amount).toFixed(2),
                invoiceNumber:item?.invoice_number?item?.invoice_number:"-"

            }))
        );
    };

    const supplierPaymentFunc = async () => {
        const startDate = moment(selectedRange?.startDate).format('YYYY-MM-DD');
        const endDate = moment(selectedRange?.endDate).format('YYYY-MM-DD');

        const payload = {
            ...filter,
            start_date: startDate,
            end_date: endDate,
            company_id: StorageServices.getCompanyId(),
            vendor_type: 1,
            vendor_id: supplierDetails?._id,
        }

        setLoading(true);

        try {
            const res = await getSupplierPaymentList(payload)

            if (res?.responseCode == 200) {
                setSuppliePaymentList(res?.data?.list)
                setTotalItems(res?.data?.total_record || 0)
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const continueForPayment = (selectTrip, totalAmount) => {
        setIsOpenFreight({ open: { selectTrip, totalAmount }, type: "freightBalance" });
        setShowAddPayOffCanva(false)
    }

    const callBackPayment = () => {
        supplierPaymentFunc()
    }

    const deleteHandler = (item) => {
        setIsDelete(item);
    };

    const submitDeleteSupplier = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageServices.getCompanyId(),
                transaction_id: isDelete?.transaction_id,
                vocher_id: isDelete?._id,
                reason: ""
            };

            const res = await deleteSupplierPayment(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                supplierPaymentFunc()
                setLoading(false);
                setIsDelete(false);
            } else {
                toast.success("Error !! ");
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error);
        }
    };

    useEffect(() => {
        if (supplierDetails?._id) {
            supplierPaymentFunc()
        }
    }, [filter, selectedRange, supplierDetails?._id])

    let makePaymentSupplierTripProps = {
        isOpen: isOpenFreight?.open,
        isOpenFreight: isOpenFreight,
        closeModal: (e) =>
            setIsOpenFreight({ ...isOpenFreight, open: false, type: "" }),
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Make Payment",
        supplierDetails: supplierDetails,
        callBackPayment: callBackPayment
    };

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?._id,
        oprnDeleteModal: setConfirmModalShow
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteSupplier,
        isLoadding: loading,
    };

    return (
        <>
            <div className='__paymentMxs_bx'>
                <div className='__payTop_flex'>
                    <div className="_divForth">
                        <CommonDateRange
                            initialStartDate={selectedRange.startDate}
                            initialEndDate={selectedRange.endDate}
                            onApply={handleApply}
                        />
                    </div>

                    <div className="__paySearch_fxs">
                        <CommonInput
                            placeholder="Search"
                            label="Search"
                            value={filter.search}
                            onChange={handleSearchChange}
                        />
                    </div>

                    <div className='__addPayNxs_flex'>
                        <button className='anime-btn __addPayNxs_btn' onClick={() => { setShowAddPayOffCanva(true) }}>
                            Add Payment
                        </button>
                    </div>
                </div>

                <div className='_tabWith_outTab'>
                    <BootstrapTable
                        columns={columns}
                        data={RowListData(supplierPaymentList?.length > 0 ? supplierPaymentList : [])}
                        isLoading={loading}
                        onRowClick={handleRowClick}
                    />

                    {(supplierPaymentList?.length > 0 && totalItems) && <div className='paginationFt_avt '>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>}
                </div>
            </div>

            <div className={`offcanvas offcanvas-end common_offCanvas  xxlOffcanvas ${showOffAddPayOffCanva ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffAddPayOffCanva ? 'visible' : 'hidden' }}
            >
                {showOffAddPayOffCanva &&
                    <AddSupplierPayment
                        isOpen={showOffAddPayOffCanva}
                        onClose={(e) => setShowAddPayOffCanva(false)}
                        supplierDetails={supplierDetails}
                        continueForPayment={continueForPayment} />
                }
            </div>
            <div className={showOffAddPayOffCanva ? 'offBack_drop' : ''}></div>
            {isOpenFreight?.open && <MakePaymentSupplierModal {...makePaymentSupplierTripProps} />}
            {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
            {isDelete?._id && (
                <CommonModal {...propsObject}>
                    <p className="p-3">
                        {" "}
                        Are you sure you want to delete ?
                    </p>
                </CommonModal>
            )}

        </>
    )
}

export default PaymentDetailsTabs